import React from "react";
import HcsControl from "./hcs-control";
import HcsInfoButton from "./hcs-info-button";

export default class HcsCaptionControl extends HcsControl {
    constructor(props) {
        super(props);
    }

    getCaption() {
        const { data } = this.props;
        return data.info.trans;
    }

    render(innerControl) {
        const { data } = this.props;

        return this.isVisible() ? super.render(
            <React.Fragment>
                <h3>{this.getCaption()}
                    {
                        data.data.TOOLTIP ?
                            <HcsInfoButton contentHtml={data.data.TOOLTIP} /> : null
                    }
                </h3>
                {innerControl}
            </React.Fragment>
        ) : null;
    }
}